<template>
  <div>
    <el-radio-group v-model="mode">
      <el-radio v-for="item in modes" :key="item.value" :label="item.value">
        {{ item.text }}
      </el-radio>
    </el-radio-group>
  </div>
</template>
<script>
import { Radio, RadioGroup } from "element-ui";

/**
 * 填写方式选择器
 */
export default {
  name: "value-mode-selector",
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  props: {
    value: {
      type: Number,
    },
    modes: {
      type: Array,
      default: () => [],
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    mode: {
      get() {
        return this.$props.value;
      },
      set(value) {
        this.$emit("change", value);
      },
    },
  },
  methods: {
    emitChange(value) {
      this.$emit("change", value);
    },
  },
};
</script>
